import React, { useEffect, useRef, useState } from "react";
import { Badge, Button, Modal, Card, Form, Container, Image, ListGroup, ProgressBar  } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { vasthuUrl } from "./Api";
import { useTranslation } from "react-i18next";
import Toast from "./Toast";
import { AiOutlineStar } from "react-icons/ai";

function ReviewBadge({ conUuid, conName, conImgUrl, conRating }) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const bottomRef = useRef(null);
  const token = window.sessionStorage.getItem("token");
  const userId = window.sessionStorage.getItem("userId");
  const [userReview, setUserReview] = useState([]);
  const [rating, setRating] = useState(3);
  //   const [conUuid, setConUuid] = useState();
  //   const [conName, setConName] = useState();
  //   const [conImgUrl, setConImgUrl] = useState();
  const [consultantStats, setConsultantStats] = useState({});
  const [fiveStars, setFiveStars] = useState(0);
  const [fourStars, setFourStars] = useState(0);
  const [threeStars, setThreeStars] = useState(0);
  const [twoStars, setTwoStars] = useState(0);
  const [oneStar, setOneStar] = useState(0);
  const [reviewDesc, setReviewDesc] = useState("");

  // ALERT MODAL
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  const alert = (msg) => {
    setMessage(msg);
    setToastTrigger((prev) => prev + 1);
  };

  // Consultant Review Confirm MODAL
  const [model1, setModel1] = useState(false);

  const modelClose1 = () => {
    setModel1(false);
  };
  const modelOpen1 = () => {
    setModel1(true);
  };

  // Consultant Review  MODAL
  const [model, setModel] = useState(false);

  const modelClose = () => {
    setModel(false);
    setModel1(false);
  };

  const modelOpen = () => {
    setModel(true);
  };

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [userReview]);

  const ConsultaionReview = () => {
    if (conUuid && token) {
      try {
        vasthuUrl
          .get(`usersreviewforconsultant/${conUuid}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            console.log("user reviews", res.data);
            setUserReview(res.data);
          });
      } catch (error) {
        console.log("ERROE" + error);
      }
      try {
        vasthuUrl
          .get(`usersreviewcountforconsultant/${conUuid}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setConsultantStats(res.data);
            console.log("user count", res.data);
            if (res.data) {
              setFiveStars(
                (res.data.rating5count / res.data.total_review_count) * 100
              );
              setFourStars(
                (res.data.rating4count / res.data.total_review_count) * 100
              );
              setThreeStars(
                (res.data.rating3count / res.data.total_review_count) * 100
              );
              setTwoStars(
                (res.data.rating2count / res.data.total_review_count) * 100
              );
              setOneStar(
                (res.data.rating1count / res.data.total_review_count) * 100
              );
            }
          });
      } catch (error) {
        console.log("ERROE" + error);
      }
    }
  };

  useEffect(() => {
    ConsultaionReview();
  }, [reviewDesc]);

  const handleSendReview = async () => {
    try {
      const response = await vasthuUrl.post(
        "/saveconsultantreview",
        {
          user_uuid: userId,
          consultant_uuid: conUuid,
          user_rating: rating,
          review_description: reviewDesc,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        alert(t("USR.REV.SUC.ALT"));
        setMessageType("success");
        setReviewDesc("");
      }
    } catch (error) {
      setMessageType("error");
      alert("Error submitting review:", error);
    }
  };

  return (
    <>
      <Toast msg={message} type={messageType} trigger={toastTrigger} />

      <Badge
        pill
        bg="warning"
        text="dark"
        size="sm"
        onClick={() => {
          if (token) {
            modelOpen1();
          } else {
            navigate("/login");
            window.sessionStorage.setItem("rerender", location.pathname);
          }
        }}
      >
        <AiOutlineStar size={15} />
        {conRating}
      </Badge>

      <Modal
        show={model1}
        backdrop="static"
        keyboard={false}
        onHide={modelClose1}
        className="all_border"
      >
        <Modal.Header closeButton className="all_background">
          <h3>{t("USR.CONST.REVIW.DETA")}</h3>
        </Modal.Header>
        <Modal.Body>
          <div>{t("USR.REVW.ALRT.MSG")}</div>
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "5%" }}
          >
            <Button className="all_btn" onClick={() => modelClose1()}>
            {t("USR.REVW.NO")}
            </Button>
            <Button className="all_btn" onClick={() => modelOpen()}>
            {t("USR.REVW.YES")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={model}
        backdrop="static"
        keyboard={false}
        onHide={modelClose}
        fullscreen={true}
        className="all_border"
      >
        <Modal.Header closeButton className="all_background">
          <h3>{t("USR.CONST.REVIW.DETA")}</h3>
        </Modal.Header>

        <Card className="all_border mx-5 p-2 mt-3">
          <center>
            {" "}
            <h6>{t("USR.BOK.HIS.RAT")}</h6>
            <div
            // style={{ display: "flex", justifyContent: "center" }}
            >
              {[...Array(5)].map((star, index) => {
                index += 1;
                return (
                  <button
                    type="button"
                    style={{
                      backgroundColor: "transparent",
                      outline: "none",
                      cursor: "pointer",
                      border: "none",
                      position: "relative",
                    }}
                    key={index}
                    className={index <= rating ? "on" : "off"}
                    onClick={() => {
                      console.log("STAR RATING", index);
                      setRating(index);
                    }}
                  >
                    <span
                      className="star"
                      style={{ fontSize: "30px", textAlign: "center" }}
                    >
                      &#9733;
                    </span>
                  </button>
                );
              })}
            </div>
          </center>

          <div className="d-flex justify-content-center g-4">
            {" "}
            <Form.Control
              as="textarea"
              className="all_border mb-2"
              rows={2}
              size="sm"
              maxLength={250}
              onChange={(e) => setReviewDesc(e.target.value)}
              placeholder="Enter your review"
              value={reviewDesc}
            />
            <Button className="all_btn mb-2" onClick={handleSendReview}>
              {t("USR.HOM.BTN.SUB")}
            </Button>
          </div>
        </Card>

        <Modal.Body>
          <>
            <Container>
              <Card className="text-center all_border mt-1">
                {consultantStats && (
                  <>
                    <Card.Header className="d-flex all_background justify-content-center align-items-center ">
                      {conImgUrl ? (
                        <Image
                          fluid
                          thumbnail
                          roundedCircle
                          style={{ width: 60, height: 60, margin: 5 }}
                          src={conImgUrl}
                          alt="profile"
                        />
                      ) : (
                        <Image
                          fluid
                          thumbnail
                          roundedCircle
                          style={{ width: 60, height: 60, margin: 5 }}
                          src={require("../images/noimage.jpg")}
                          alt="profile"
                        />
                      )}
                      <h5 className="pt-2">
                        {conName} <br />
                        <Badge bg="danger" pill>
                          {consultantStats.average_rating}/5.0
                        </Badge>{" "}
                        ({consultantStats.total_review_count})
                      </h5>
                    </Card.Header>
                    <Card.Body>
                      <ListGroup style={{ border: "1px solid #ffb33e" }}>
                        <ListGroup.Item
                          as="li"
                          className="d-flex justify-content-between align-items-center "
                        >
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            5 - {t("PR.AC.RVWTAB.STRS.CMM")}
                          </h6>
                          <ProgressBar
                            className="d-flex"
                            style={{ width: "70%" }}
                            variant="success"
                            now={fiveStars}
                          />
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            {consultantStats.rating5count}
                          </h6>
                        </ListGroup.Item>
                        <ListGroup.Item
                          as="li"
                          className="d-flex justify-content-between align-items-center "
                        >
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            4 - {t("PR.AC.RVWTAB.STRS.CMM")}
                          </h6>
                          <ProgressBar
                            style={{ width: "70%" }}
                            variant="info"
                            now={fourStars}
                          />
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            {consultantStats.rating4count}
                          </h6>
                        </ListGroup.Item>
                        <ListGroup.Item
                          as="li"
                          className="d-flex justify-content-between align-items-center "
                        >
                          {" "}
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            3 - {t("PR.AC.RVWTAB.STRS.CMM")}
                          </h6>
                          <ProgressBar
                            style={{ width: "70%" }}
                            variant="warning"
                            now={threeStars}
                          />
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            {consultantStats.rating3count}
                          </h6>
                        </ListGroup.Item>
                        <ListGroup.Item
                          as="li"
                          className="d-flex justify-content-between align-items-center "
                        >
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            2 - {t("PR.AC.RVWTAB.STRS.CMM")}
                          </h6>
                          <ProgressBar
                            style={{ width: "70%" }}
                            variant="danger"
                            now={twoStars}
                          />
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            {consultantStats.rating2count}{" "}
                          </h6>
                        </ListGroup.Item>
                        <ListGroup.Item
                          as="li"
                          className="d-flex justify-content-between align-items-center "
                        >
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            1 - {t("PR.AC.RVWTAB.STR.CMM")}
                          </h6>
                          <ProgressBar
                            style={{ width: "70%" }}
                            variant="primary"
                            now={oneStar}
                          />
                          <h6 className="mt-2" style={{ color: "grey" }}>
                            {consultantStats.rating1count}
                          </h6>
                        </ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                  </>
                )}
              </Card>
              {userReview.length > 0 ? (
                <Card className="mt-2">
                  <Card.Header className="text-center" as="h3">
                    {t("PR.AC.RVWTAB")}
                  </Card.Header>
                  {userReview.map((i, j) => (
                    <Card.Body key={j}>
                      <div className="review-list">
                        <ul>
                          <li>
                            <div className="d-flex">
                              <div className="left">
                                <span>
                                  <img
                                    src="https://bootdey.com/img/Content/avatar/avatar1.png"
                                    className="profile-pict-img img-fluid"
                                    alt="userProfile"
                                  />
                                </span>
                              </div>
                              <div className="right">
                                <h4>
                                  {i.user.userName}
                                  <span className="gig-rating text-body-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 1792 1792"
                                      width="15"
                                      height="15"
                                    >
                                      <path
                                        fill="currentColor"
                                        d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"
                                      ></path>
                                    </svg>
                                    {i.user_rating}
                                  </span>
                                </h4>
                                <div className="country d-flex align-items-center">
                                  <div className="country-name font-accent">
                                    {i.user.email}
                                  </div>
                                </div>
                                <div className="review-description">
                                  <p>{i.review_description}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </Card.Body>
                  ))}
                  <div ref={bottomRef}></div>
                </Card>
              ) : (
                <center>
                  <h5 className="mt-3">{t("PR.AC.RVWTAB.MSG.NORVW")}</h5>
                </center>
              )}
            </Container>
            <Button
              className="all_btn mt-2"
              style={{
                float: "right",
              }}
              onClick={() => modelClose()}
            >
              {t("TXT.CLO.LO")}
            </Button>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ReviewBadge;
